import FileReferenceDefinition from '../FileReferenceDefinition';

const definition: FileReferenceDefinition = {
  name: 'UrlChangedEventArgs',
  type: 'class',
  description: 'Event args for [UrlChanged](/webview/IWebView#UrlChanged).',
  inheritsFrom: 'System.EventArgs',
  members: [
    {
      name: 'Url',
      returns: 'string',
      type: 'property',
      description: 'The new URL.'
    }
  ]
};
export default definition;
